import { useState, useEffect } from "react";
import axios from "axios";
import { Card, CardContent } from "./components/ui/card";
import { Select, SelectItem, SelectContent, SelectTrigger } from "./components/ui/select";
import { Input } from "./components/ui/input";
import { Button } from "./components/ui/button";
import './styles.css';

const AIRTABLE_API_KEY = "patLSykafxrvTuKrP.54be854b58e4ff801684c98db883d3bd0bf9c3e0dacd2b75149e3d73f887a7ab";
const BASE_ID = "appzuoHWU2izp3Ah1";
const TABLE_NAME_NUMBERS = "PhoneNumbers";
const TABLE_NAME_PAIR = "pair";

export default function LuckyNumberChatbot() {
  const [preference, setPreference] = useState("");
  const [results, setResults] = useState([]);
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [pairNumber, setPairNumber] = useState({});
  const [userPhoneNumber, setUserPhoneNumber] = useState("");
  const [unluckyPairs, setUnluckyPairs] = useState([]);
  const [isUnlucky, setIsUnlucky] = useState(null);
  const [userScore, setUserScore] = useState(null);
  const [selectedPhone, setSelectedPhone] = useState(null);
  const [foundUnluckyPairs, setFoundUnluckyPairs] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const phoneResponse = await axios.get(
          `https://api.airtable.com/v0/${BASE_ID}/${TABLE_NAME_NUMBERS}`,
          { headers: { Authorization: `Bearer ${AIRTABLE_API_KEY}` } }
        );
        const numbers = phoneResponse.data.records.map(record => ({
          number: record.fields.number,
          price: record.fields.Price
        }));
        setPhoneNumbers(numbers);

        const pairResponse = await axios.get(
          `https://api.airtable.com/v0/${BASE_ID}/${TABLE_NAME_PAIR}`,
          { headers: { Authorization: `Bearer ${AIRTABLE_API_KEY}` } }
        );

        const pairData = {};
        const unluckyData = [];
        pairResponse.data.records.forEach(record => {
          pairData[record.fields.pair.trim()] = record.fields.value;
          if (record.fields.type === "unlucky") {
            unluckyData.push(record.fields.pair.trim());
          }
        });

        setPairNumber(pairData);
        setUnluckyPairs(unluckyData);
      } catch (error) {
        console.error("Error fetching data from Airtable:", error);
      }
    };
    fetchData();
  }, []);

  const calculateScore = (number) => {
    let score = 0;
   const bonusPrefixes = ["289", "789", "782", "636", "369", "689", "168", "898", "356", "154", "246", "595", "159", "236", "456", "565", "393", "494"];
    if (bonusPrefixes.includes(number.substring(3, 6))) {
      score += 25;
    }
    for (let i = 3; i < number.length - 1; i++) {
      const pair = number.substring(i, i + 2);
      if (pairNumber[pair]) {
        score += pairNumber[pair];
      }
    }
    return score;
  };

  const handleCheckUnlucky = () => {
    if (userPhoneNumber.length === 10) {
      let foundUnlucky = false;
      let unluckyPairsFound = [];
      for (let i = 3; i < userPhoneNumber.length - 1; i++) {
        const pair = userPhoneNumber.substring(i, i + 2).trim();
        if (unluckyPairs.includes(pair)) {
          foundUnlucky = true;
          unluckyPairsFound.push(pair);
        }
      }
      setIsUnlucky(foundUnlucky);
      setFoundUnluckyPairs(unluckyPairsFound);
      setUserScore(calculateScore(userPhoneNumber));
    } else {
      setIsUnlucky(null);
      setUserScore(null);
      setFoundUnluckyPairs([]);
    }
  };

  const handlePhoneClick = (phone) => {
    setSelectedPhone(phone);
  };

  useEffect(() => {
    if (!preference || phoneNumbers.length === 0) {
      setResults([]);
      return;
    }

    let filterCriteria = new RegExp(".*");
    switch (preference) {
      case "ความสุข ความสำเร็จ":
        filterCriteria = /^.{3}159/;
        break;
      case "เสน่ห์เมตตามหานิยม ค้าขาย":
        filterCriteria = /^.{3}246/;
        break;
      case "เสน่ห์ ความรัก":
        filterCriteria = /^.{3}636/;
        break;
      case "ธุรกิจขนาดใหญ่ เงินก้อนใหญ่":
        filterCriteria = /^.{3}(789|782)/;
        break;
      default:
        filterCriteria = /.*/;
    }

    const filteredNumbers = phoneNumbers.filter(phone => filterCriteria.test(phone.number));
    const scoredResults = filteredNumbers.map(phone => ({
      ...phone,
      score: calculateScore(phone.number)
    }));
    setResults(scoredResults);
  }, [preference, phoneNumbers, pairNumber]);

  return (
    <div className="p-6 max-w-md mx-auto bg-white rounded-xl shadow-md space-y-4">
      <h1 className="text-2xl font-bold text-center text-gray-800">🔮 Dr.Mobile AI </h1>
      <h1 className="text-2xl font-bold text-center text-gray-800">       ตรวจเบอร์มงคล</h1>
      <div className="space-y-4">
        <Input
            	type="text"
  	placeholder="🏦 ใส่เบอร์โทร10หลักของคุณ"
  	value={userPhoneNumber}
  	onChange={(e) => setUserPhoneNumber(e.target.value)}
  	maxLength={10}
  	className="w-full p-2 border rounded-md bg-yellow-100" 
	/>

        <Button onClick={handleCheckUnlucky} className="w-full bg-blue-500 text-white p-2 rounded-md">คลิกตรวจสอบ</Button>
        {isUnlucky !== null && (
          <p className={`text-lg text-center font-semibold mt-2 ${isUnlucky ? 'text-red-500' : 'text-green-500'}`}>
            {isUnlucky ? `เบอร์นี้ไม่เป็นเบอร์มงคล - คู่เลขไม่มงคลคือ ${foundUnluckyPairs.join(', ')}` : 'เบอร์นี้เป็นเบอร์มงคล'} (คะแนน: {userScore})
          </p>
        )}
      </div>
<br />  {/* Line Break */}
<label className="block text-gray-700 font-medium mb-2">เลือกประเภทเบอร์มงคลที่ใช่ ในช่องเขียว </label>
<label className="block text-gray-700 font-medium mb-2">และกดเบอร์ที่ชอบเพื่อดูข้อมูล</label>
<Select
  value={preference}
  onValueChange={setPreference}
  placeholder="😊 เลือกสิ่งที่คุณต้องการ"
  className="w-72 p-2 border border-gray-300 rounded-md bg-green-100 focus:outline-none focus:ring-2 focus:ring-green-400"
>
  <SelectItem value="ความสุข ความสำเร็จ">😊 ความสุข ความสำเร็จ</SelectItem>
  <SelectItem value="เสน่ห์เมตตามหานิยม ค้าขาย">💰 เสน่ห์เมตตามหานิยม ค้าขาย</SelectItem>
  <SelectItem value="เสน่ห์ ความรัก">❤️ เสน่ห์ ความรัก</SelectItem>
  <SelectItem value="ธุรกิจขนาดใหญ่ เงินก้อนใหญ่">🏦 ธุรกิจขนาดใหญ่ เงินก้อนใหญ่</SelectItem>
</Select>


      <div className="mt-6">
        {results.length > 0 && (
          <Card>
            <CardContent>
              <h2 className="text-lg font-semibold">{preference}</h2>
              <ul>
                {results.map((res, index) => (
                  <li
                    key={index}
                    className="mt-2 text-lg font-medium text-gray-700 cursor-pointer"
                    onClick={() => handlePhoneClick(res)}
                  >
                    {res.number.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')}   (คะแนน: {res.score})
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>
        )}
      </div>

      {selectedPhone && (
        <Card className="mt-4">
          <CardContent>
            <h2 className="text-lg font-semibold">เบอร์ที่เลือก:</h2>
            <p className="text-md font-medium text-gray-700">
              เบอร์: {selectedPhone.number.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')}
            </p>
            <p className="text-md font-medium text-gray-700">
              ราคา: {selectedPhone.price ? `${selectedPhone.price} บาท` : 'ไม่มีข้อมูลราคา'}
            </p>
            <p className="text-md font-medium text-gray-700">
              สนใจติดต่อไลน์ไอดี drmobile :
            </p>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
